import api from "./axios";

export interface CreditAccount {
  id: number;
  clientId: number;
  client: { id: number; firstName: string; lastName: string; phone: string };
  limitAmount: number;
  paymentTermDays: number;
  pipelineId: number | null;
  pipeline: { id: number; name: string } | null;
  stageId: number | null;
  stage: { id: number; name: string } | null;
  allowedProductIds: number[] | null;
  allowedCategoryIds: number[] | null;
  isActive: boolean;
  createdAt: string;
}

export interface CreditOrder {
  id: number;
  creditAccountId: number;
  clientId: number;
  client: { id: number; firstName: string; lastName: string };
  dealId: number | null;
  deal: { id: number; number: string } | null;
  siteOrderId: number | null;
  amount: number;
  dueDate: string;
  status: "pending" | "paid" | "overdue" | "cancelled";
  items: Array<{ productId: number; nameRu: string; quantity: number; price: number }>;
  paidAt: string | null;
  createdAt: string;
}

export interface CreditBalance {
  account: CreditAccount | null;
  usedAmount: number;
  availableAmount: number;
  overdueOrders: CreditOrder[];
  pendingOrders: CreditOrder[];
}

export interface CreateCreditAccountDto {
  clientId: number;
  limitAmount: number;
  paymentTermDays: number;
  pipelineId?: number;
  stageId?: number;
  allowedProductIds?: number[] | null;
  allowedCategoryIds?: number[] | null;
  isActive?: boolean;
}

// ── Аккаунты ──
export const getAccounts = () =>
  api.get<CreditAccount[]>("/credit/accounts").then(r => r.data);

export const getAccountByClient = (clientId: number) =>
  api.get<CreditAccount | null>(`/credit/accounts/client/${clientId}`).then(r => r.data);

export const createAccount = (dto: CreateCreditAccountDto) =>
  api.post<CreditAccount>("/credit/accounts", dto).then(r => r.data);

export const updateAccount = (id: number, dto: Partial<CreateCreditAccountDto>) =>
  api.put<CreditAccount>(`/credit/accounts/${id}`, dto).then(r => r.data);

export const deleteAccount = (id: number) =>
  api.delete(`/credit/accounts/${id}`).then(r => r.data);

// ── Баланс ──
export const getBalance = (clientId: number) =>
  api.get<CreditBalance>(`/credit/balance/${clientId}`).then(r => r.data);

// ── Заказы ──
export const getOrders = () =>
  api.get<CreditOrder[]>("/credit/orders").then(r => r.data);

export const getOrdersByClient = (clientId: number) =>
  api.get<CreditOrder[]>(`/credit/orders/client/${clientId}`).then(r => r.data);

export const payOrder = (id: number, method: string = 'cash') =>
  api.post<CreditOrder>(`/credit/orders/${id}/pay`, { method }).then(r => r.data);

export const cancelOrder = (id: number) =>
  api.post<CreditOrder>(`/credit/orders/${id}/cancel`).then(r => r.data);

export const markOverdue = () =>
  api.post("/credit/orders/mark-overdue").then(r => r.data);
